
import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import MasterICCardImportForm from 'components/organismos/master/MasterICCardImportForm';

const MasterICCardImportPage = () => (
    <SidebarTemplate>
        <MasterICCardImportForm/>
    </SidebarTemplate>
);

export default MasterICCardImportPage;
